import { useEffect, useState } from 'react';

export const useOperatingSystem = () => {
  const [os, setOS] = useState('other');
  useEffect(() => {
    try {
      const userAgent = navigator?.userAgent?.toLowerCase() || '';
      if (userAgent.includes('mac')) setOS('mac');
      else if (userAgent.includes('win')) setOS('windows');
      else if (userAgent.includes('linux')) setOS('linux');
      else setOS('other');
    } catch (error) {
      setOS('other');
    }
  }, []);

  return os;
};
